export default {
  name: "F3DScaleAItem",
  components: {},
  props: {
    flag: {
      type: Number,
      default: null
    },
    idx: {
      type: Number,
      default: 0
    },
    imgIdx: {
      type: Number,
      default: 1
    },
    choosed: {
      type: Number,
      default: 0
    },
    showIdx: {
      type: Boolean,
      default: false
    },
    showBox: {
      type: Boolean,
      default: false
    },
    answerMode: {
      type: Boolean,
      default: false
    },
    // 这里的highlight是代表目标图形与左侧图例相同，为减少修改此处进行注释不修改变量名
    highlight: {
      type: Boolean,
      default: false
    },
    subject: {
      type: String,
      default: 'A'
    },
    line: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      chooseSide: 0
    };
  },
  methods: {
    onLeftClick() {
      if (this.chooseSide == 1) {
        this.chooseSide = 0;
        this.$emit('clearChoose', this.idx);
        return;
      }
      this.chooseSide = 1;
      this.$emit('choosed', this.idx);
    },
    onRightClick() {
      if (this.chooseSide == 2) {
        this.chooseSide = 0;
        this.$emit('clearChoose', this.idx * -1);
        return;
      }
      this.chooseSide = 2;
      this.$emit('choosed', this.idx * -1);
    },
    getJudgment() {
      let result = true;
      // highlight 代表目标图形与左侧图例相同  
      switch (this.subject) {
        case 'A':
          // A 题型为相同选左  则相同的 choosed 应该为 1
          result = this.highlight && this.choosed === 1 || !this.highlight && this.choosed === 0;
          break;
        case 'B':
          // B 相同的图形情况下  星星后面的 choosed 应该为 2  非星星的应该为 1    星星标志为flag == 1
          if (this.flag === 1) {
            result = this.highlight && this.choosed === 2 || !this.highlight && this.choosed === 0;
          } else {
            result = this.highlight && this.choosed === 1 || !this.highlight && this.choosed === 0;
          }
          break;
        case 'C':
          // 规定行数为奇数时，Ｏ为特殊图形，行数为偶数时，☆为特殊图形，若特殊图形后的图形与图例相同，则点选每个目标图形右侧的方格；不同则点选左边
          // 星星标志为flag == 1  Ｏ为flag == 0
          // this.choosed  1为左  2为右
          // highlight 为 true 与左边图例相同
          // line + 1 判断行奇偶

          // 偶数
          if ((this.line + 1) % 2 === 0) {
            if (this.flag === 1) {
              result = this.highlight && this.choosed === 2 || !this.highlight && this.choosed === 0;
            } else {
              result = this.highlight && this.choosed === 1 || !this.highlight && this.choosed === 0;
            }
          } else {
            if (this.flag === 0) {
              result = this.highlight && this.choosed === 2 || !this.highlight && this.choosed === 0;
            } else {
              result = this.highlight && this.choosed === 1 || !this.highlight && this.choosed === 0;
            }
          }
          break;
      }
      return result ? '✅' : '❌';
    },
    init() {}
  },
  mounted() {
    this.init();
  }
};